// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2tHxy","wrapper-nopadding":"wrapper-nopadding__39VaR","loading":"loading__1eMHL","error":"error__LfRJR","table-loading":"table-loading__2heMq","empty-val":"empty-val__3Ovjm","panelheader-tools":"panelheader-tools__ez79F","propsPanels":"propsPanels__1C4VO","new":"new__1uWwU","marginLm":"marginLm__3jCI6","marginRm":"marginRm__13Vdh","fullWidth":"fullWidth__EQnKq","fullHeight":"fullHeight__uJPyG","noData":"noData__2_Vu_","errorblock":"errorblock__2hj0E"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/ChannelView/coms/DeleteChannelPlanModal/styles.scss
// module id = 2290
// module chunks = 1